import { decode64 } from '../utils/decode.ts';
import { type TrackEventEventArgument } from '../utils/tracking/searchBrowse/filterTracking.ts';

export const TOGGLE_FILTER_DISPLAY = 'TOGGLE_FILTER_DISPLAY' as const;
export function toggleFilterDisplay(shown?: boolean): {
    type: typeof TOGGLE_FILTER_DISPLAY;
    payload?: boolean;
} {
    return { type: TOGGLE_FILTER_DISPLAY, payload: shown };
}

export const TOGGLE_REQUEST_IN_FLIGHT = 'TOGGLE_REQUEST_IN_FLIGHT' as const;
export function toggleRequestInFlight(payload: boolean): {
    type: typeof TOGGLE_REQUEST_IN_FLIGHT;
    payload: boolean;
} {
    return { type: TOGGLE_REQUEST_IN_FLIGHT, payload };
}

type FilterValue = { urlLabel?: string | null; linkReference?: string | null } | null;
type UpdateUriRefPayload = {
    filterName?: string;
    filterValue?: FilterValue;
    uriRef?: string | null;
    isFromTypeahead?: boolean;
    isDeselected?: boolean;
    isDynamic?: boolean;
    ga?: Record<string, unknown>;
    event?: TrackEventEventArgument;
};
export const UPDATE_URI_REF = 'UPDATE_URI_REF' as const;
export function updateUriRef({
    filterName,
    filterValue,
    uriRef,
    isFromTypeahead = false,
    isDeselected = false,
    isDynamic = false,
    ga,
    event,
}: UpdateUriRefPayload): {
    type: typeof UPDATE_URI_REF;
    payload: {
        uriRef: string | null | undefined;
        filterName?: string;
        filterValue?: FilterValue;
        isFromTypeahead: boolean;
        isDeselected: boolean;
        isDynamic: boolean;
        ga?: Record<string, unknown>;
        event?: TrackEventEventArgument;
    };
} {
    if (!uriRef) {
        const { linkReference } = filterValue || {};
        uriRef = linkReference && decode64(linkReference);
    }

    return {
        type: UPDATE_URI_REF,
        payload: {
            uriRef,
            filterName,
            filterValue,
            isFromTypeahead,
            isDeselected,
            isDynamic,
            ga,
            event, // actionSanitizer function from src/reducers/reducerUtils.js could be deleted when event is no longer used
        },
    };
}

export const UPDATE_ZIP_CODE = 'UPDATE_ZIP_CODE' as const;
export function updateZipCode(zipCode: string): {
    type: typeof UPDATE_ZIP_CODE;
    payload: string;
} {
    return { type: UPDATE_ZIP_CODE, payload: zipCode };
}

export type FilterAction =
    | ReturnType<typeof toggleFilterDisplay>
    | ReturnType<typeof toggleRequestInFlight>
    | ReturnType<typeof updateUriRef>
    | ReturnType<typeof updateZipCode>;
